import { useRouter } from '@tanstack/react-router';
import { useRegisterBreadcrumbs } from '@/services/breadcrumbs';
import { generatePath } from '@/services/router/generate-path';

const INTEGRATIONS_INDEX_PATH = '/workspaces/:workspaceId/integrations';

/** Where an unknown `:type` lands: the Connections tab of the directory. */
export function integrationsOverviewHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/integrations/all/overview', { workspaceId });
}

/**
 * `Integrations / <name>`.
 *
 * The leaf is registered even while the catalog loads, with the id read back as
 * a name, so the trail does not shift once the record lands.
 */
export function useExternalIntegrationBreadcrumbs(workspaceId: string, type: string, name: string): void {
  const router = useRouter();

  useRegisterBreadcrumbs([
    {
      id: 'integrations',
      text: 'Integrations',
      href: generatePath(INTEGRATIONS_INDEX_PATH, { workspaceId }),
    },
    {
      id: 'integrations_type',
      text: name,
      href: router.buildLocation({
        to: '/workspaces/$workspaceId/integrations/$type',
        params: { workspaceId, type },
      }).href,
    },
  ]);
}
